import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import AdminBase from "components/layout/AdminBase";
import ProviderPayoutReportTable from "components/provider/widgets/ProviderPayoutReportTable";
import { getProviders } from "api/ProviderApi";
import filter from "lodash/filter";
import map from "lodash/map";
import orderBy from "lodash/orderBy";
import * as ProviderApi from "api/ProviderApi";
import {
  PermissionTypes,
  userHasPermission,
} from "utils/permissions/rolesPermissions";
import * as UserPermissions from "constants/UserPermissions";
import Dropdown from "components/common/Dropdown";
import Button from "components/common/Button";
import TextBox from "components/common/TextBox";
import CorporateGroupDropdown from "components/registration/elements/CorporateGroupDropdown";
import { handleErrorResponse } from "utils/request";
import { BOEHRINGER_INGELHEIM } from "constants/ProviderIds";

function AdminPayoutReport(props) {
  const [checkSummary, setCheckSummary] = useState(null);
  const [groupDropDownValue, setGroupDropDownValue] = useState(null);
  const [dropDownValue, setDropDownValue] = useState(1);
  const [checkNumber, setCheckNumber] = useState(null);
  const [downloadParameters, setDownloadParameters] = useState({});
  const [manufacturers, setManufacturers] = useState(null);
  const [loading, setLoading] = useState(false);

  const checkNumberInputStyle = {
    marginTop: "0.5rem",
  };

  const fetchData = async () => {
    setLoading(true);    
    getProviders()
    .then((res) => {
        const mans = filter(res.body, { visibleInCorporateDashboard: true });
        const ddOptions = map(mans, item => ({
            value: item.id,
            name: item.name
          }));
        setManufacturers(ddOptions);
        setDropDownValue(BOEHRINGER_INGELHEIM);
    })
    .catch((err) => {
        handleErrorResponse("loading Manufacturers", err);
    })
    .finally(() => {
        setLoading(false);
    })
  };

  useEffect(() => {
    if (!manufacturers?.length) {
      fetchData();
    }
    }, []);

  const loadPayoutReport =  (model) => {    
      ProviderApi.getAdminCheckSummary(model)
      .then((res) => {
        let recs = map(res.body, (d) => ({
            ...d,
            id: d.clinicId,
        }));
        setCheckSummary(recs);
      })
      .catch((error) => {
        handleErrorResponse("loading payout report", error);
      })
  };

  const handleStatusFilterChanged = (option) => {
    setDropDownValue(option.value);
  };

  const handleGroupFilterChanged = (option) => {
    setGroupDropDownValue(option.value);
  };

  const handleCheckInput = (number) => {
    setCheckNumber(number.value);
  };

  const handleSubmit = () => {
    let search = ({
      manufacturerId: dropDownValue,
      checkNumber: checkNumber,
      corporateGroupProviderId: groupDropDownValue,
    });
    loadPayoutReport(search);
  };

  useEffect(() => {    
      setDownloadParameters({
        "manufacturerId": dropDownValue,
        "checkNumber": checkNumber,
        "corporateGroupProviderId": groupDropDownValue,
      })
  }, [dropDownValue, groupDropDownValue, checkNumber])

  return (
    <AdminBase pageTitle="Admin Payout Report">    
      <div>
        <div className="flex flex-wrap">
          {props.canViewAdminPayoutReport && (
          <div className="flex-none flex flex-centered spaced-content margin-sm">
            <CorporateGroupDropdown
                data-testid="corp-group-dropdown"
                label=""
                name="ddlGroup"
                value={groupDropDownValue}
                onChange={handleGroupFilterChanged}
                required
            />
          </div>
          )}
          <div className="flex-none flex flex-centered spaced-content margin-sm">
            <Dropdown
                data-testid="provider-dropdown"
              name="ddlProvider"
              value={dropDownValue}
              onChange={handleStatusFilterChanged}
              options={manufacturers}
              required
              wide
            />
          </div>
          <div className="flex-none flex flex-centered spaced-content margin-sm">
            <TextBox
              data-testid="text-check-number"
              name="checkNumber"
              placeholder="Enter Check Number..."
              style={checkNumberInputStyle}
              value={checkNumber}
              onChange={(data) => handleCheckInput(data)}
              input={true}
            />
          </div>
          <div className="flex-none flex flex-centered spaced-content margin-sm">
            <Button
              className="margin-right-x-sm"
              onClick={() => handleSubmit()}
              disabled={!checkNumber || !groupDropDownValue}
            >
              Search
            </Button>
          </div>
        </div>
          <ProviderPayoutReportTable
            isAdminReport={true}
            canViewAdminPayoutReport={props.canViewAdminPayoutReport}
            checkData={checkSummary}
            downloadParameters={downloadParameters}
            isNHO={false}
          />        
      </div>
      </AdminBase>
  );
}

export default connect(
  (state, ownProps) => {
    const userProfile = state.user.userProfile;
    //Permissions
    const canViewAdminPayoutReport = userHasPermission(PermissionTypes.VIEW, UserPermissions.ADMIN_PROVIDER_PAYOUT_REPORT, userProfile); 
    return {
      userProfile,
      // Permissions
      canViewAdminPayoutReport,
    };
  }
)(AdminPayoutReport);
